/* eslint-disable no-console */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import Switch from 'react-switch'

import Header from '../../components/Header'
import Button from '../../components/Button'

import welcomeEnd from '../../assets/welcome-end.svg'

const BemVindo: React.FC = () => {
  const [acceptTerms, setAcceptTerms] = useState(false)

  const navigate = useNavigate()
  const [quantity] = useState(3)
  const [active, setActive] = useState(0)

  const handleSetProximo = useCallback(() => {
    const newActive = active + 1
    if (newActive < quantity) {
      setActive(newActive)
    }
  }, [active, quantity])

  const handleSetAnterior = useCallback(() => {
    const newActive = active - 1
    if (newActive >= 0) {
      setActive(newActive)
    }
  }, [active])

  const toggleAcceptTerms = useCallback(() => {
    setAcceptTerms(!acceptTerms)
  }, [acceptTerms, setAcceptTerms])

  const handleStart = useCallback(async () => {
    if (acceptTerms) {
      navigate('/register')
    } else {
      console.warn('is necessary accept the terms to continue.')
    }
  }, [acceptTerms, navigate])

  // useEffect(() => {
  //   localStorage.removeItem('@Iprejun:documentsAttached')
  //   localStorage.removeItem('@Iprejun:erroProps')
  //   localStorage.removeItem('@Iprejun:participantsGroup')
  //   localStorage.removeItem('@Iprejun:servicestimeGroup')
  //   localStorage.removeItem('@Iprejun:tipoContato')
  //   localStorage.removeItem('@Iprejun:userData')
  // }, [])

  return (
    <>
      <Header />
      <div className="mx-auto mb-[15px] flex max-w-[600px] flex-col items-center px-[5px] max-[766px]:max-w-[550px]">
        <main className="flex flex-col w-full items-center justify-center rounded-[8px] bg-white p-[30px_5px] text-center shadow-[0px_2px_4px_rgba(0,0,0,0.05),0px_6px_12px_rgba(61,69,67,0.05)] max-[766px]:max-w-[550px]">
          <div className="flex flex-col items-center justify-center gap-6 p-10">
            <img src={welcomeEnd} alt="Carteira" className="mb-8 h-[160px]" />
            <p>
              Este formulário é destinado ao cadastro de servidores ativos do
              Município de Jundiaí para acesso e vinculação ao Regime Próprio de
              Previdência Social (RPPS).
            </p>
            <p>
              As informações declaradas serão utilizadas exclusivamente para
              fins previdenciários e de gestão cadastral.
            </p>

            <div className="text-end flex w-full items-center justify-between gap-4">
              <small className="">
                Ao continuar navegando no site, você concorda com as condições
                de{' '}
                <a
                  href="https://aspprev.com.br/"
                  target="_blank"
                  className="text-blue-600 hover:underline"
                >
                  Privacidade
                </a>{' '}
                e{' '}
                <a
                  href="https://aspprev.com.br/"
                  target="_blank"
                  className="text-blue-600 hover:underline"
                >
                  Termos de uso
                </a>{' '}
                do site.
              </small>
              <Switch
                onChange={toggleAcceptTerms}
                checked={acceptTerms}
                checkedIcon={false}
                uncheckedIcon={false}
                height={22}
                width={44}
                handleDiameter={18}
                offColor="#DEE3E1"
                offHandleColor="#fff"
                onHandleColor="#fff"
                onColor="#31D19E"
              />
            </div>
          </div>
          <Button color="blue" onClick={handleStart} disabled={!acceptTerms}>
            Começar
          </Button>
        </main>
      </div>
    </>
  )
}

export default BemVindo
